module.exports = __webpack_public_path__ + "static/template-about-history-background-fb09fd2d7f733dd26f5c8b55bbbb7a5c.jpg";